export default __webpack_public_path__ + "static/media/cj-case-study-logo.82d665e9.png";